import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "src/app/modules/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.auth.verifySession()) {
      this.auth.signInWithCookies().subscribe({
        next: (response) => {
          return new BehaviorSubject(true);
        },
          error: (error) => {
            // if not authorized, goto login method
          return new BehaviorSubject(this.login());
        },
      });
    }
    return new BehaviorSubject(true);
  }

  // check() {
  //   // if (this.auth.currentUser) {
  //   //   return true;
  //   // }
  //   return this.auth.verifySession().pipe(
  //     map((user) => {
  //       if (!user) {
  //         return this.login();
  //       }
  //       return true;
  //     }),
  //     catchError((error, caught) => {
  //       console.error(error);
  //       return new BehaviorSubject(this.login());
  //     })
  //   );
  // }

    login() {
        return this.router.createUrlTree(["unauthorized-access"]);
        //return this.router.createUrlTree(["login"]);
  }
}
